import * as React from 'react';
import '@react-three/fiber';
import CustomShaderMaterial$1 from '../vanilla/dist/three-custom-shader-material-vanilla.esm.js';
import 'object-hash';
import 'three';
import 'glsl-tokenizer';
import 'glsl-token-string';
import 'glsl-token-functions';

var CustomShaderMaterial = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var material = React.useRef(new CustomShaderMaterial$1(props));
  React.useEffect(function () {
    return function () {
      return material.current.dispose();
    };
  }, []);
  return /*#__PURE__*/React.createElement("primitive", {
    object: material.current,
    attach: "material",
    ref: ref
  });
});

export { CustomShaderMaterial as default };
